import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_CREATE = gql `
  mutation AdminWineryMemberCreate($input: AdminWineryMemberCreateInput!) {
    AdminWineryMemberCreate(input: $input)
  }
`;
